import React, { useRef } from "react";
import { Modal, Container } from "react-bootstrap";
import ProjectInformationSection from "./ProjectInformationSection";
import AddDecisionSection from "./AddDecisionSection";
import { AddedDecisionList } from "./AddedDecisionsList";
import NoDecisionAddedSection from "./NoDecisionAddedSection";

const ProjectAddDecisionModal = props => {
  const goToAddDecisionForm = useRef();
  const goToAddedDecisionList = useRef();
  const {
    show,
    onHide,
    projectData,
    projectAddedDecisionData,
    projectAddDecisionStatus,
    isUserPMG
  } = props;
  const showAddDecisionSection = event => {
    goToAddDecisionForm.current.scrollIntoView({ behavior: "smooth" });
  };
  const showAddedDecisionList = isFormSubmitted => {
    if (
      goToAddedDecisionList.current !== undefined &&
      isFormSubmitted === true
    ) {
      goToAddedDecisionList.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-select-issue project-add-decision-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Meeting Decisions</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`${
          projectAddedDecisionData.data.length === 0 && !isUserPMG
            ? "no-decision-modal-body"
            : ""
        }`}
      >
        <div ref={goToAddedDecisionList}>
          <ProjectInformationSection
            projectData={projectData}
            showAddDecisionSection={showAddDecisionSection}
            isUserPMG={isUserPMG}
          />
        </div>
        {projectAddedDecisionData.data.length !== 0 && (
          <AddedDecisionList
            projectAddedDecisionData={projectAddedDecisionData}
          />
        )}
        {projectAddedDecisionData.data.length === 0 && !isUserPMG && (
          <NoDecisionAddedSection />
        )}
        {isUserPMG && (
          <div ref={goToAddDecisionForm}>
            <AddDecisionSection
              showAddedDecisionList={showAddedDecisionList}
              projectData={projectData}
              projectAddDecisionStatus={projectAddDecisionStatus}
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProjectAddDecisionModal;
